// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2AkI6","paramInput":"JobSimulator_paramInput__1lfNx","input":"JobSimulator_input__1rhk0"};